import * as React from 'react'

function IconTimeLesson(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={67}
      height={67}
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.194 65.394c17.78 0 32.194-14.415 32.194-32.197C65.388 15.415 50.974 1 33.194 1S1 15.415 1 33.197C1 50.98 15.414 65.394 33.194 65.394z"
        fill="#fff"
      />
      <path
        d="M33.194 65.394c17.78 0 32.194-14.415 32.194-32.197C65.388 15.415 50.974 1 33.194 1S1 15.415 1 33.197C1 50.98 15.414 65.394 33.194 65.394z"
        stroke="#A3A3A3"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M33.194 60.882c15.288 0 27.682-12.395 27.682-27.685S48.482 5.513 33.194 5.513c-15.288 0-27.681 12.395-27.681 27.684 0 15.29 12.393 27.684 27.681 27.684z"
        stroke="#A3A3A3"
        strokeWidth={0.75}
        strokeMiterlimit={10}
      />
      <path
        d="M33.15 48.005c8.204 0 14.856-6.651 14.856-14.856s-6.652-14.857-14.857-14.857c-8.205 0-14.857 6.652-14.857 14.857 0 8.205 6.652 14.856 14.857 14.856z"
        stroke="#A2A2A2"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M33.149 25.129v5.812c0 1.414.56 2.772 1.562 3.774l3.404 3.403"
        stroke="#A2A2A2"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconTimeLesson
